function escalateMember(memberId, groupId=undefined) {
  let url = window.location.origin
  const escalatePath = url + `/workflow_queues/customer_service_action/${memberId}/member/${memberId}/CUSTSERVE_CALL?description=Customer+Service+Call&group_id=${groupId}`;
  window.open(escalatePath, '_blank');
}

export default escalateMember;
